export const enumKeys = (E: any): string[] => {
  return Object.keys(E).filter(key => typeof E[key as any] === "number");
};

export enum DocumentContextUri {
  Application = "applications",
  Policy = "policies"
}

export enum CustomersFilter {
  RecentlyViewed = "viewed",
  RecentlyCreated = "created"
}

export enum PoliciesTabs {
  RecentlyViewed = "recentlyViewed",
  RecentlyIssued = "recentlyIssued",
  OpenQuotes = "openQuotes",
  OpenRenewals = "openRenewals",
  OpenChanges = "openChanges",
  OpenCancellations = "openCancellations"
}

export enum TasksTabs {
  YourOpen = "yourOpen",
  YourCompleted = "yourCompleted",
  AllOpen = "allOpen",
  AllCompleted = "allCompleted",
  AllCancelled = "allCancelled"
}

export enum PolicyType {
  PersonalAuto = "Personal Auto",
  Homeowners = "Homeowners"
}

export enum ApplicationType {
  Quote = "Quote",
  QuickQuote = "QuickQuote"
}

export enum ApplicationStatus {
  Closed = "Closed",
  InProcess = "In Process",
  PendingApproval = "Pending Approval"
}

export enum StepStatus {
  PENDING = "pending",
  ACTIVE = "active",
  COMPLETE = "complete"
}

export enum PersonalAutoQuickStep {
  PolicyGeneral,
  DriverDetail,
  VehicleDetail,
  EstimatedPremium
}

export enum PersonalAutoStep {
  PolicyGeneral,
  InsuredInformation,
  QualificationQuestions,
  DriverDetail,
  VehicleDetail,
  PaymentPlans
}

export enum HomeownerQuickStep {
  PolicyGeneral,
  Coverages,
  EstimatedPremium
}

export enum HomeownerStep {
  PolicyGeneral,
  InsuredInformation,
  QualificationQuestions,
  PropertyDetails,
  CoverageDetail,
  AdditionalInterests,
  PaymentPlans
}
